import scrollTo from 'gatsby-plugin-smoothscroll';
import React from 'react';

import { contactBlockId } from '../../helpers';


const homepage = {
    intro: {
        title: 'Sovereign Quantum for MENA',
        subTitle: (
            <>
                The first quantum computing company born in the region.<br />
                We engineer solutions here — we don't just import them.
            </>
        ),
        cta: {
            to: 'contactUs',
            children: 'Contact Us',
            onClick: () => scrollTo(`#${contactBlockId}`),
        },
    },
    divider: {},
    subIntro: {
        leftAligned: true,
        children: (
            <>
                <p>Classical optimization hits fundamental limits. Current encryption will be broken by quantum computers. The organizations that prepare now will lead; those that wait will scramble.</p>
            </>
        ),
    },
    divider00: {},
    cardsGroup: {
        title: 'Two Verticals. One Mission.',
        children: [
            {
                icon: 'icon-processor',
                slug: 'fenneq',
                title: (
                    <>
                        FENNEQ<br />
                        AI & Optimization Platform
                    </>
                ),
                card: "Transform complex business problems into optimized solutions. No PhD required. No mathematical modeling. No quantum expertise. Upload your data, describe your constraints, and our platform does the rest.",
            },
            {
                icon: 'icon-shield-check',
                slug: 'qaser',
                title: (
                    <>
                        QASER<br />
                        Sovereign Post-Quantum Cryptography
                    </>
                ),
                card: "Homegrown post-quantum cryptography. QamiaScanner finds your exposure. QamiaLayer protects in 4 weeks — zero code changes. Full NIST ML-KEM and ML-DSA implementations.",
            },
        ],
    },
    divider0: {},
    subIntro1: {
        children: (
            <>
                <h2>Why Sovereign Quantum Matters</h2>
            </>
        ),
    },
    cardsGroup1: {
        children: [
            {
                icon: 'icon-pin',
                title: 'Data Residency',
                card: "Your optimization models and cryptographic keys never leave the region. Full compliance with regional data localization requirements.",
            },
            {
                icon: 'icon-clipboard-check',
                title: 'Regulatory Alignment',
                card: "Solutions architected for GCC compliance frameworks from day one. We understand local regulatory landscapes.",
            },
            {
                icon: 'icon-layers',
                title: 'Strategic Independence',
                card: "Reduce reliance on foreign technology vendors for critical infrastructure. Own your quantum future.",
            },
            {
                icon: 'icon-users',
                title: 'Direct Access to the Builders',
                card: "Work directly with the engineers who built the platform. Not a call center — the actual PhDs who wrote the algorithms. Regional presence means real support.",
            },
            {
                icon: 'icon-award',
                title: 'Economic Development',
                card: "Contributing to MENA's knowledge economy and technical talent base. Building the region's quantum workforce.",
            },
        ],
    },
    divider1: {},
    subIntro2: {
        children: (
            <>
                <h2>Production-Ready. Battle-Tested.</h2>
            </>
        ),
    },
    cardsGroup2: {
        children: [
            {
                icon: 'icon-send',
                title: 'Aviation',
                card: "Stand allocation deployed at major regional airport. Measurable efficiency gains in ground operations.",
            },
            {
                icon: 'icon-broadcast',
                title: 'Telecommunications',
                card: "Network paging optimization for regional operators. Significant reduction in signaling load.",
            },
            {
                icon: 'icon-power',
                title: 'Energy',
                card: "Grid optimization and resource scheduling pilots with regional utilities.",
            },
            {
                icon: 'icon-shield-check',
                title: 'Government',
                card: "Post-quantum cryptography assessments for critical infrastructure.",
            },
        ],
    },
    divider2: {},
    quote: {
        children: (
            <>
                Qamia is the first quantum computing company<br />
                born in the MENA region.
            </>
        ),
        cta: {
            url: `/about-us`,
            children: 'About Us',
        },
    },
};

export default homepage;
